import moment from 'moment';
import { floatRenderer } from '../../../services/formatSvc';

const initialKpiState = {
  name: null,
  unit: null,
  required: null,
  startDate: null,
  endDate: null,
  projTypes: [],
};

const labels = {
  name: 'Название',
  unit: 'Единицы измерения',
  required: 'Обязательный',
  startDate: 'Дата начала',
  endDate: 'Дата конца',
  projTypes: 'Тип',
};

const mapUserName = (user) => `${user?.lastName || ''} ${user?.firstName || ''} ${user?.middleName || ''}`;

const getMappedEntry = (entry, changeDescr, oper) => ({
  createdOn: entry.createdOn,
  userName: mapUserName(entry.user),
  oper: oper || entry.oper,
  changeDescr,
});

const renderValue = (value, key) => {
  switch (key) {
    case 'required':
      return value ? 'Да' : 'Нет';
    case 'startDate':
      return moment.utc(value).format('DD.MM.YYYY');
    case 'endDate':
      return moment.utc(value).format('DD.MM.YYYY');
    default:
      return value;
  }
};

const mapHistoryEntry = (entry) => {
  const result = [];

  if (entry.changes) {
    const { changes } = entry;

    const descrChanged = [];

    const previousState = changes.prevVal ? { ...changes.prevVal } : { ...initialKpiState };

    for (const [key, value] of Object.entries(changes.val)) {
      if (previousState[key] !== value && key !== 'projTypes') {
        descrChanged.push(`${labels[key]}: ${renderValue(value, key)}`);
      }
      if (key == 'projTypes') {
        if (previousState[key]?.map((e) => e.name).join(',') !== value?.map((e) => e.name).join(',')) descrChanged.push(`${labels[key]}: ${renderValue(value?.map((e) => e.name).join(','), key)}`);
      }
    }

    if (descrChanged.length) {
      result.push(getMappedEntry(entry, descrChanged.join('\n')));
    }
  } else {
    result.push(entry);
  }

  return result;
};

export const mapResponseHistory = (responseHistory) => responseHistory.reduce((acc, entry) => [...acc, ...mapHistoryEntry(entry)], []);
